import { createFileRoute } from "@tanstack/react-router";
import { SwapPage } from "../../features/swap/pages/swap-page";
import { prefetchSdkMetadata } from "../../shared/utils/metadata-data";

export const Route = createFileRoute("/_layout/swap")({
  loader: () => prefetchSdkMetadata(),
  component: SwapPage,
});
